/**
 * DevExtreme (esm/__internal/scheduler/r1/components/base/group_panel_horizontal_cell.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import { createVNode, createComponentVNode } from "inferno";
import { BaseInfernoComponent } from "../../../../core/r1/runtime/inferno/index";
import { PublicTemplate } from "../../../../scheduler/r1/components/templates/index";
import { combineClasses } from "../../../../core/r1/utils/render_utils";
import { GroupPanelCellDefaultProps } from "./group_panel_props";
export const GroupPanelHorizontalCellDefaultProps = _extends({}, GroupPanelCellDefaultProps, {
  isFirstGroupCell: false,
  isLastGroupCell: false,
  colSpan: 1
});
export let GroupPanelHorizontalCell = /*#__PURE__*/(() => {
  class GroupPanelHorizontalCell extends BaseInfernoComponent {
    render() {
      const {
        cellTemplate: cellTemplate,
        colSpan: colSpan,
        color: color,
        data: data,
        id: id,
        index: index,
        text: text,
        className: className,
        isFirstGroupCell: isFirstGroupCell,
        isLastGroupCell: isLastGroupCell
      } = this.props;
      const classes = combineClasses({
        "dx-scheduler-group-header": true,
        "dx-scheduler-first-group-cell": isFirstGroupCell,
        "dx-scheduler-last-group-cell": isLastGroupCell,
        [className ?? ""]: Boolean(className)
      });
      return createVNode(1, "th", classes, createVNode(1, "div", "dx-scheduler-group-header-content", cellTemplate ? createComponentVNode(2, PublicTemplate, {
        template: cellTemplate,
        templateProps: {
          data: {
            data: data,
            id: id,
            color: color,
            text: text
          },
          index: index
        }
      }) : createVNode(1, "div", null, text, 0), 0), 2, {
        colspan: colSpan
      });
    }
  }
  GroupPanelHorizontalCell.defaultProps = GroupPanelHorizontalCellDefaultProps;
  return GroupPanelHorizontalCell;
})();